"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionHelper = void 0;
var moment = require("moment");
var enums_1 = require("./enums");
var productHelper_1 = require("./productHelper");
var InteractionHelper = /** @class */ (function () {
    function InteractionHelper() {
    }
    InteractionHelper.getQuoteType = function (product) {
        product = productHelper_1.productHelper.decodeShortenedProduct(product) || "";
        switch (product) {
            case enums_1.ProductsEnum.MOTOR:
                return "car";
            case enums_1.ProductsEnum.RENTERS:
                return "renters";
            default:
                throw new Error("Uknown product - ".concat(product));
        }
    };
    InteractionHelper.getAllDrivers = function (interaction) {
        var drivers = [];
        if (interaction) {
            if (interaction.policyHolder) {
                drivers.push(interaction.policyHolder);
            }
            if (interaction.additionalDrivers) {
                drivers.push.apply(drivers, interaction.additionalDrivers);
            }
        }
        return drivers;
    };
    InteractionHelper.getDrivingLicenceNumber = function (driver) {
        var _a;
        var dln = (_a = driver === null || driver === void 0 ? void 0 : driver.licence) === null || _a === void 0 ? void 0 : _a.number;
        return dln && dln.replace(/\s+/g, '').toUpperCase();
    };
    /**
     * Determines whether 2 drivers are the same person.
     *
     * Note: If at least one of the drivers doesn't have a DLN,
     * then both drivers' DLNs are considered equal,
     * regardless whether or not the other driver has a DLN.
     * Source: FAL-18277 (https://lv-digital.atlassian.net/browse/FAL-18277)
     *
     * @param driver1 - driver to compare
     * @param driver2 - driver to compare
     * @returns true if drivers are equal; false otherwise
     */
    InteractionHelper.driversEqual = function (driver1, driver2) {
        var _a, _b;
        if (!driver1 || !driver2) {
            throw new Error("Cannot compare drivers: ".concat(!driver1 ? "driver1" : "driver2", " is undefined"));
        }
        var dln1 = (_a = this.getDrivingLicenceNumber(driver1)) === null || _a === void 0 ? void 0 : _a.slice(0, 16);
        var dln2 = (_b = this.getDrivingLicenceNumber(driver2)) === null || _b === void 0 ? void 0 : _b.slice(0, 16);
        var dlnsEqual;
        if (!dln1 || !dln2) {
            dlnsEqual = true;
        }
        else {
            dlnsEqual = dln1 === dln2;
        }
        return (dlnsEqual &&
            driver1.firstName.toLowerCase() === driver2.firstName.toLowerCase() &&
            driver1.lastName.toLowerCase() === driver2.lastName.toLowerCase() &&
            moment.utc(driver1.dateOfBirth).startOf("day").isSame(moment.utc(driver2.dateOfBirth).startOf("day")));
    };
    InteractionHelper.isMonthlyQuoteAllowed = function (interaction) {
        var _a;
        return ((_a = interaction.polarisPolicyData) === null || _a === void 0 ? void 0 : _a.instalmentAllowedStatus) === "A";
    };
    InteractionHelper.isPolicyQuotedBeforeFamilyCoverRemoval = function (interaction) {
        var _a, _b, _c;
        // For renewals use renewalQuoteDate instead of originalQuoteDate (NB quote date)
        var quoteDate = (_b = (_a = interaction === null || interaction === void 0 ? void 0 : interaction.factors) === null || _a === void 0 ? void 0 : _a.renewalQuoteDate) !== null && _b !== void 0 ? _b : (_c = interaction === null || interaction === void 0 ? void 0 : interaction.factors) === null || _c === void 0 ? void 0 : _c.originalQuoteDate;
        var coverRemovalDate = moment(process.env.REACT_APP_FAMILY_COVERAGE_REMOVAL_DATE);
        // Quote date might be null during NB journey before Polaris Call, in this case need to use current day to determine
        return quoteDate ? moment(quoteDate).isBefore(coverRemovalDate) : moment().isBefore(coverRemovalDate);
    };
    return InteractionHelper;
}());
exports.InteractionHelper = InteractionHelper;
//# sourceMappingURL=InteractionHelper.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/helpers/InteractionHelper.js
// module id = 447
// module chunks = 0